// extracted by mini-css-extract-plugin
export var bottomRightDock = "_3i-0";